// extracted by mini-css-extract-plugin
export default {"text":"EditPayPopup_text__CzBXs","field":"EditPayPopup_field__3DQny"};